/* src/app/modules/portal/components/advanced-search/advanced-search.component.scss */
.advanced-search {
  display: flex;
  height: calc(100vh - 72px);
}
/*# sourceMappingURL=advanced-search.component.css.map */
